import { GovIcon } from '@gov-design-system-ce/react';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import { PageCode } from '@gov-nx/module/page';
import { Button, Dialog } from '@gov-nx/ui/web';

type CancelPromptProps = {
	isOpen: boolean;
	onConfirm: () => void;
	onCancel: () => void;
};

export const CancelPrompt = ({
	isOpen,
	onConfirm,
	onCancel,
}: CancelPromptProps) => {
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tn = getLocalizeCurried(PageCode['datove-schranky']);

	return (
		<Dialog
			onClose={onCancel}
			isOpen={isOpen}
			icon={
				<GovIcon
					name="exclamation-triangle-fill"
					type="components"
					color="error"
				/>
			}
			title={<h3>{tn('nova-zprava.opravdu-chcete-prestat-psat')}</h3>}
			footer={
				<>
					<Button
						color="primary"
						nativeType="button"
						type="base"
						size="m"
						onClick={onCancel}
						aria-label={tn('nova-zprava.pokracovat')}>
						{tn('nova-zprava.pokracovat')}
					</Button>
					<Button
						color="error"
						nativeType="button"
						onClick={onConfirm}
						type="solid"
						size="m"
						aria-label={tn('nova-zprava.prestat-psat')}>
						{tn('nova-zprava.prestat-psat')}
					</Button>
				</>
			}>
			<p>{tn('nova-zprava.zprava-se-zahodi')}</p>
		</Dialog>
	);
};
